import { MapAdminSettings } from "@features/portal-administration/components/MapAdminSettings";
import { hasPermission } from "@features/rbac/permissions";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/admin/map")({
	beforeLoad: () => {
		if (!hasPermission("map.manage")) throw redirect({ to: "/unauthorised" });
	},
	component: MapAdminSettings,
	staticData: { crumb: { label: "Map" } },
});
